// extracted by mini-css-extract-plugin
module.exports = {"highway":"_5b10bb2305--highway--uTG9V","icon":"_5b10bb2305--icon--amvzZ"};